export class ShipmentActionDeliverStop {

    public rowVersion : string = '';

    constructor(rowVersion : string) {
        this.rowVersion = rowVersion;
    }

}
